export default {
  title_one: '🥳 {{offer}} applied',
  title_other: '🥳 {{count}} offers applied',
};
